import { Component, OnInit, ViewChild } from "@angular/core";

@Component({
  selector: "szz-dashboard-page",
  templateUrl: "./dashboard-page.component.html",
  styleUrls: ["./dashboard-page.component.scss"]
})
export class DashboardPageComponent implements OnInit {

  constructor(
  ) {}

  ngOnInit() {
  }

}
